// libs
import React from 'react';
import moment from "moment/moment";

// components
import PreviousCards from './PreviousCards';
import ClipboardIcon from "../../../../../components/ClipboardIcon";
import LoadingSpinner from "../../../../../components/LoadingSpinner";
import SystemErrorMessage from "../../../../../components/SystemErrorMessage";
import HelpTip from "../../../../../components/HelpTip";
import AuthService from "../../../../../services/AuthService";
import { Link } from 'react-router-dom';
import NotFound from '../../../../NotFound';

const MembershipDetails = (props) => {
    const { member, isResendCardEnabled, onPressResendCard, isLoadingResendCard, resendCardResult, resendCardError } = props;
    const rewardsExpiryDateLabelClass = 'text--color';

    let rewardsStatusClass = 'btn--lime';

    if (member.rewardsStatus === 'Expired' || member.rewardsStatus === 'Card Replaced' || member.rewardsStatus === 'Deleted') {
        rewardsStatusClass = 'btn--red';
    } else if (member.rewardsStatus === 'Pending' || member.rewardsStatus === 'Not a Member') {
        rewardsStatusClass = 'btn--yellow';
    }

    const rewardsEnrolmentDate = member.rewardsEnrolmentDate ? moment(member.rewardsEnrolmentDate).format('D MMMM YYYY') : '-';
    const rewardsExpiryDate = member.rewardsExpiryDate ? moment(member.rewardsExpiryDate).format('D MMMM YYYY') : '-';

    const _onResendCardPressed = (event) => {
        event.preventDefault();
        onPressResendCard();
    };

    const isDigitalLoyaltyEnabled = AuthService.isDigitalLoyaltyEnabled();

    return (
        <div className="margin--30--bot relative">
            <h3 className="sub-title margin--10--bot">Membership</h3>

            {!isLoadingResendCard && resendCardResult && <div className="alert alert--success alert--outline text--center margin--10--bot">{resendCardResult}</div>}
            {!isLoadingResendCard && resendCardError !== null && <SystemErrorMessage message={resendCardError} notified={false} />}

            <ul className="list--box list--info">
                <li className={isLoadingResendCard ? 'loading--inline' : ''}>
                    {member.rewardsStatus !== '' && <span
                        className={'f-right btn btn--tiny ' + rewardsStatusClass}>{member.rewardsStatus}</span>}
                    <p className="list--info__label text--break">
                        <strong className="text--caps text--color">Card
                            Number&nbsp;</strong>
                        <span
                            className="margin--20--right">{member.rewardsCardNumber}</span>
                        <ClipboardIcon text={member.rewardsCardNumber} />
                    </p>
                    {isDigitalLoyaltyEnabled && <p className="list--info__label">
                        <strong className="text--caps text--color">Card Type</strong>
                        {member.rewardsCardType}
                    </p>}
                    <p className="list--info__label"><strong
                        className="text--caps text--color">Enrolment
                        Date</strong> {rewardsEnrolmentDate}</p>
                    <p className="list--info__label"><strong
                        className={'text--caps ' + rewardsExpiryDateLabelClass}>Expiry
                        Date</strong> {rewardsExpiryDate}&nbsp;
                        {member.isRewardsExpiringSoon &&
                            <small className="text--red">(Expires soon)</small>}
                    </p>
                    {member.rewardsStatus !== 'Active' &&
                        <p className="list--info__label"><strong
                            className="text--caps text--color">Note</strong> {member.rewardsExpiryText}
                        </p>
                    }
                    <PreviousCards member={member} />
                    {isDigitalLoyaltyEnabled &&
                        <div className="margin--20--top">
                            {isResendCardEnabled && AuthService.can('Email membership card') &&
                                <button className="btn btn--small btn--color" onClick={_onResendCardPressed}>Email Card</button>
                            }
                            {!isResendCardEnabled && AuthService.can('Email membership card') &&
                                <button className="btn btn--small btn--color" disabled="disabled">Email Card</button>
                            }
                            {!isResendCardEnabled &&
                                <HelpTip><span>Member must subscribe to newsletter to receive emails.</span></HelpTip>
                            }
                            {/* {(AuthService.getAdminType() == 1 || AuthService.getAdminType() == 2 || AuthService.getAdminType() == 3) && */}
                            {AuthService.can('View purchase history') &&
                                <Link to={{ 'pathname': '/members/' + member.slug + '/viewPurchaseHistory', 'state': { 'prevPath': location.pathname } }} className="btn btn--small btn--color btn--open f-right"> View Purchase History <img className="icon" src="/img/icon-arrowOpen--white.svg" width="10" height="10" /></Link>
                            }
                        </div>
                    }

                    {isLoadingResendCard && <LoadingSpinner isVisible={true} />}
                </li>
            </ul>
        </div>
    );
};

export default MembershipDetails;
